import { createFormData } from 'src/helpers';
import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IDuplicateMenuRequest } from '../types';

export const duplicateMenu = async (menuId: string, payload: IDuplicateMenuRequest): Promise<any> => {
  const requestBody = createFormData(payload);

  const res = await fetch(`${API_URL}/menus/${menuId}/duplicate`, {
    method: 'POST',
    body: requestBody,
  });

  if (!res.ok) {
    throw new Error('We have been unable to complete your request. Please try again');
  }

  return res;
};
